import React, { useEffect, useState } from 'react';
import { FaSearch, FaTrash, FaPlus } from 'react-icons/fa';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function SectionList() {
    const [sections, setSections] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(100);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [sectionId, setSectionId] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [deviceType, setDeviceType] = useState('desktop');
    const [preview, setPreview] = useState(null);
    const [sectionName, setSectionName] = useState('');
    const [active, setActive] = useState(true);


    const fetchSections = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/section-images`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const result = await res.json();
            setSections(result.sections || result || []);
        } catch (error) {
            console.error('Error fetching section images:', error);
        }
    };

    useEffect(() => {
        fetchSections();
    }, []);

    const filteredSections = sections.filter(section =>
        Object.values(section).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const currentSections = filteredSections.slice(indexOfLastItem - itemsPerPage, indexOfLastItem);
    const totalPages = Math.ceil(filteredSections.length / itemsPerPage);

    const handleAddSection = async () => {
        const token = localStorage.getItem('authToken');
        const formData = new FormData();
        formData.append('image_file', imageFile);
        formData.append('device_type', deviceType);
        formData.append('section_name', sectionName);
        formData.append('active', active);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/section-images`, {
                method: 'POST',
                headers: { Authorization: `Bearer ${token}` },
                body: formData
            });
            if (!res.ok) throw new Error('Failed to upload section image');
            fetchSections();
            resetForm();
            setShowModal(false);
        } catch (err) {
            console.error(err);
        }
    };

    const handleDeleteClick = (id) => {
        setSectionId(id);
        setShowDeleteModal(true);
    };

    const handleDeleteSection = async () => {
        const token = localStorage.getItem('authToken');
        try {
            await fetch(`${process.env.REACT_APP_API_URL}/section-images/${sectionId}`, {
                method: 'DELETE',
                headers: { Authorization: `Bearer ${token}` },
            });
            fetchSections();
            setShowDeleteModal(false);
        } catch (err) {
            console.error('Error deleting section image:', err);
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const resetForm = () => {
        setImageFile(null);
        setPreview(null);
        setDeviceType('desktop');
        setSectionName('');
        setActive(true);
    };

    return (
        <div className="container" style={{ marginTop: '80px' }}>
            <h2 className="text-primary">Section Images</h2>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="input-group me-3" style={{ maxWidth: '300px' }}>
                    <span className="input-group-text bg-primary text-white">
                        <FaSearch />
                    </span>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search sections..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <button className="btn btn-success" onClick={() => setShowModal(true)}>
                    <FaPlus /> Add Section
                </button>
            </div>

            <table className="table table-bordered table-striped">
                <thead className="table-primary">
                    <tr>
                        <th>ID</th>
                        <th>Device</th>
                        <th>Name</th>
                        <th>Image</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentSections.map((section) => (
                        <tr key={section.section_imagesId}>
                            <td>{section.section_imagesId}</td>
                            <td>{section.device_type}</td>
                            <td>{section.section_name}</td>
                            <td><img src={section.image_url} alt="" width="100" /></td>
                            <td>{section.active ? 'Active' : 'Deactive'}</td>
                            <td>{new Date(section.CreatedAt).toLocaleDateString()}</td>
                            <td>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteClick(section.section_imagesId)}>
                                    <FaTrash /> Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <nav>
                <ul className="pagination justify-content-center">
                    {[...Array(totalPages)].map((_, i) => (
                        <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                            <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                                {i + 1}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>

            <Modal show={showModal} onHide={() => { setShowModal(false); resetForm(); }}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Section</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Device</Form.Label>
                            <Form.Select value={deviceType} onChange={(e) => setDeviceType(e.target.value)}>
                                <option value="desktop">Desktop</option>
                                <option value="mobile">Mobile</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Section Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter section name"
                                value={sectionName}
                                onChange={(e) => setSectionName(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Check
                                type="checkbox"
                                label="Active"
                                checked={active}
                                onChange={(e) => setActive(e.target.checked)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Upload Image</Form.Label>
                            <Form.Control type="file" accept="image/*" onChange={handleImageChange} />
                            {preview && (
                                <img src={preview} alt="Preview" className="img-fluid mt-2" />
                            )}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setShowModal(false); resetForm(); }}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleAddSection}>
                        Add
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this section image?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                    <Button variant="danger" onClick={handleDeleteSection}>Delete</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default SectionList;
